import { useState, useEffect } from 'react';

export function useAgentVersion() {
  const [version, setVersion] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch('/api/', {
          credentials: 'include',
        });

        // Tenta pegar do header primeiro
        const headerVersion = response.headers.get('X-Agent-Version');
        if (headerVersion) {
          setVersion(headerVersion);
          return;
        }

        // Fallback: tenta pegar do JSON response
        const data = (await response.json()) as { version?: string };
        if (data.version) {
          setVersion(data.version);
        }
      } catch (error) {
        console.error('Erro ao buscar versão do agente:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVersion();
  }, []);

  return { version, loading };
}
